export function initialize() {
    CONFIG.authHeader = "X-KAV-SessionId";
    CONFIG.useExtraordinarySurvey = true;
    //CONFIG.useStandardHeader = false;
    //CONFIG.useStandardFooter = false;
    //CONFIG.authenticationHandler = function (path, continuation) {... }
    // authenticationHandler(pfadAusURL, FortsetzungsFunktion) muß bereitgestellt werden, wenn CONFIG.useIntegratedLogin auf false gesetzt wird
    // Rückgabe: truthy => Fehlermeldung (wird angezeigt), falsy => alles ok
    // Im Erfolgsfall muß der AuthenticationHandler die FortsetzungsFunktion mit einem Objekt {sessionId: <Session Id>} als Argument aufrufen
    CONFIG.deviationReason.items = ["Einstellung des Geschäftbetriebs", "Fluktuation"];

    // Survey Customization Hooks (in window.SurveyHooks setzen)
    // e.g. window.SurveyHooks.onStarting = function(){ console.log("huhu");}
    // - onStarting() wird beim Start der Erhebungs-Seite aufgerufen, vor dem Request
    // - onDataLoaded(erhebungsdatenResponse, dates) wird nach dem Erhalt der Erhebungsdaten aufgerufen
    // - onConfigureGrid(gridConfig, erhebungDaten) wird vor der Erzeugung des Grids aufgerufen, gridConfig ist das Konfigurations-Objekt des Grids, aus dem dann das Grid erzeugt wird
    // - onConfigureControl(name, type, config, validatorConfig) #todo doc
    // - onFormCreated(erhebungDaten, useGridMode, controls) wird nach der Erzeugung aller Oberflächen-Elemente aufgerufen  #todo doc
    //   Achtung: in controls stehen nur die vom Standard-Code erzeugten Controls. Die eigenen könnten hier hinzugefügt werden.
    // - onSaveValidate(erhebungDaten, useGridMode, errors)  #todo doc
    // - onSavePrepareResponse(response, useGridMode) Response um projektspezifische Daten ergänzen (z.B. RP Ortsgemeindedaten);
    // - onBeforeSave(response, saveAction) ggf. noch Rückfragen in Dialog; weitermachen mit Aufruf saveAction; wenn vorhanden, erfolgt keine Rückfrage bei 0 Beschäftigten!
    // - onRefreshAfterSave(erhebungDaten, useGridMode)
    // - onRowUpdating(e, surveyData) #todo doc
    // - onRowUpdated(e, surveyData) #todo doc
    // - onLoginError(jqXHR) #todo doc
    // - onFetchDataError(jqXHR) #todo doc

    // Texte ohne Default-Werte ------------------------------------
    // Login Außerordentliche Erhebung
    Messages["LOGINX_DOC_TITLE"] = "KAV Baden-Württemberg Personalbestandserhebung online für Neumitglied"; // document.title
    Messages["LOGINX_COMMONHEAD_TITLE"] = "Personalstandserhebung online - Neumitglied" //  $("#common-head-title").text();
    Messages["LOGINX_POPUP_TITLE"] = "Anmeldung [KAV BW Personalbestandserhebung Neumitglied]"; // Login parameter popupTitle
    // normales Login
    Messages["LOGIN_POPUP_TITLE"] = "Anmeldung [KAV BW Personalbestandserhebung online]";
}